<div class="content">
    <ol>
        <li i18n>Place new shoe in position.</li>
        <li i18n>Confirm new shoe placement by pressing the button "Shoe in place"</li>
        <li i18n>Continue with burn procedure in next steps.</li>
    </ol>

    <button i18n mat-raised-button color="primary" (click)="onShoeChangedClick(shoeChangedButton)" #shoeChangedButton>Shoe in place</button>
</div>
